import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getPresignedUploadUrl(fileName: string): Observable<any> {
    return this.#http.getData<any>(
      `${this.baseUrl}/filesystem/file/presigned-upload?fileName=${encodeURIComponent(fileName)}`,
      { showLoader: true, showMessage: false }
    );
  }

  uploadToS3(presignedUrl: string, file: File): Observable<any> {
    return this.#http.awsFileUpload<any>(presignedUrl, file, { showLoader: false, showMessage: false });
  }

  completePresignedUpload(uploadDetails: any, replaceExisting: boolean): Observable<any> {
    return this.#http.postData<any>(
      `${this.baseUrl}/filesystem/file/presigned-upload/complete?replaceExisting=${replaceExisting}`,
      { showLoader: false, showMessage: false },
      uploadDetails
    );
  }
}
